export default __webpack_public_path__ + "05c91b39493c9c514f143faefd904049.png";